<loading [visible]="loading() || saving()"></loading>

@if (!loading()) {
<app-custom-modal [customTitle]="(id ? 'Editar' : 'Nuevo') + ' usuario'" (closeFunction)="closeFunction.emit()"
    (acceptFunction)="save()">
    <form [formGroup]="form" class="space-y-4">

        <custom-input [autofocus]="true" label="Nombre" type="text"
            [formControlItem]="form.get('name')"></custom-input>

        <custom-input label="Nombre de usuario (opcional, para iniciar sesión)" type="text"
            [formControlItem]="form.get('username')" [errorMessages]="usernameErrors"></custom-input>

        <custom-input label="Email" type="email"
            [formControlItem]="form.get('email')"></custom-input>

        <custom-input [label]="id ? 'Nueva contraseña (dejar vacío para no cambiar)' : 'Contraseña'"
            type="password" [formControlItem]="form.get('password')"></custom-input>

        <div class="flex flex-col gap-1">
            <label class="text-sm font-medium text-slate-700">Rol</label>
            <select formControlName="role_id"
                class="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-300 bg-white">
                <option [ngValue]="null" disabled>Selecciona un rol</option>
                @for (role of roles; track role.id) {
                <option [ngValue]="role.id">{{ role.name }}</option>
                }
            </select>
        </div>

    </form>
</app-custom-modal>
}
